<template>
  <div class="font-AlternateGotFont text-5xl font-light text-STblue uppercase">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    text: String,
  },
};
</script>